import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { interaction_arrows_chevronRight } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { CardContainerPresentation } from '../CardContainer/CardContainerPresentation.js';
import { getGridColumnClasses } from '../GridColumn/GridColumnPresentation.js';
import { HeadlinePresentation } from '../Headline/HeadlinePresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import { hostClass } from './CardsItem.styles.js';

// TODO: Harmonising margins are a essential part. Especially the paragraph component, which currently have a margin right. Therefore it doesn't fit in middle axis very well.
// TODO: So rework of paragraph component to remove margin right?
function hasExtraAction(actionsNode) {
  return /*#__PURE__*/React.isValidElement(actionsNode) && !!(actionsNode.props.href || actionsNode.props.onClick || actionsNode.props.actionAs);
}
var defaultProps = {
  centeredLayout: false
};
var CardsItemPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;
  var standardArrowRightIcon = interaction_arrows_chevronRight;
  var id = props.id,
    className = props.className,
    isStencilHost = props.isStencilHost,
    children = props.children,
    name = props.name,
    disabled = props.disabled,
    onClick = props.onClick,
    htmlAttrs = props.htmlAttrs,
    noMargin = props.noMargin,
    href = props.href,
    actionRef = props.actionRef,
    onMouseHoverChange = props.onMouseHoverChange,
    onKeyboardFocusChange = props.onKeyboardFocusChange,
    thumbImgSrc = props.thumbImgSrc,
    thumbIcon = props.thumbIcon,
    thumbIconVariant = props.thumbIconVariant,
    thumbTitle = props.thumbTitle,
    headline = props.headline,
    headlineAs = props.headlineAs,
    overline = props.overline,
    overlineAs = props.overlineAs,
    subline = props.subline,
    sublineAs = props.sublineAs,
    centeredLayout = props.centeredLayout,
    look = props.look,
    actions = props.actions,
    showLinkLabel = props.showLinkLabel,
    linkLabel = props.linkLabel,
    linkIcon = props.linkIcon,
    itemsPerRow = props.itemsPerRow,
    actionAs = props.actionAs,
    actionProps = props.actionProps,
    gridColumnSize = props.gridColumnSize;
  var anyContentForBottomArea = look === "icon-card" || !disabled && !!linkIcon && !!linkLabel;
  var hasAnyAction = !!onClick || !!href || hasExtraAction(actions);
  var size = gridColumnSize || 12 / itemsPerRow;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    role: "listitem",
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject, getGridColumnClasses({
      size: size,
      sm: 4,
      xs: 4
    }), true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(CardContainerPresentation, {
    key: "bottomArea".concat(headline),
    active: look !== "inactive-card" && hasAnyAction,
    disabled: disabled,
    hasHover: look !== "inactive-card" && hasAnyAction,
    contentAlignment: centeredLayout ? "center" : undefined,
    // TODO: why use an array for topArea?
    topArea: [/*#__PURE__*/React.createElement(React.Fragment, {
      key: "1"
    }, thumbIcon && look !== "icon-card" && /*#__PURE__*/React.createElement(IconPresentation, {
      icon: thumbIcon,
      size: "large",
      title: thumbTitle,
      variant: thumbIconVariant
    }), thumbImgSrc && /*#__PURE__*/React.createElement("div", {
      className: "".concat(hostClass, "-image-container")
    }, /*#__PURE__*/React.createElement("img", {
      src: thumbImgSrc,
      alt: thumbTitle
    })), /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({
      id: id,
      disabled: disabled || !hasAnyAction,
      hasTabIndex: true,
      name: name,
      actionRef: actionRef,
      onMouseHoverChange: onMouseHoverChange,
      onKeyboardFocusChange: onKeyboardFocusChange,
      expandToOverlay: true
    }, hasExtraAction(actions) && {
      htmlAttrs: actions.props.htmlAttrs,
      href: disabled ? undefined : actions.props.href,
      onClick: actions.props.onClick,
      actionAs: actions.props.actionAs,
      actionProps: actions.props.actionProps
    } || {
      htmlAttrs: htmlAttrs,
      href: disabled ? undefined : href,
      onClick: onClick,
      actionAs: actionAs,
      actionProps: actionProps
    }), thumbIcon && look === "icon-card" ? /*#__PURE__*/React.createElement("div", {
      className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-content"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-content__center"), centeredLayout), _cleanupClassObject2))
    }, /*#__PURE__*/React.createElement(IconPresentation, {
      icon: thumbIcon,
      size: "large",
      title: thumbTitle,
      variant: thumbIconVariant
    })) : /*#__PURE__*/React.createElement(HeadlinePresentation, {
      size: "h4",
      as: headlineAs,
      overline: overline,
      overlineAs: overlineAs,
      subline: subline,
      sublineAs: sublineAs,
      centeredLayout: centeredLayout
    }, headline), children))],
    // TODO: why use an array for bottomArea?
    bottomArea: actions || anyContentForBottomArea && [/*#__PURE__*/React.createElement(React.Fragment, {
      key: "1"
    }, actions, look === "icon-card" && /*#__PURE__*/React.createElement(HeadlinePresentation, {
      size: "h4",
      as: headlineAs,
      centeredLayout: centeredLayout
    }, headline), !disabled && linkLabel && linkIcon && /*#__PURE__*/React.createElement("div", {
      key: "bottomArea".concat(headline),
      className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-content"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-content__center"), centeredLayout), _cleanupClassObject3))
    }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
      href: href,
      htmlAttrs: htmlAttrs,
      icon: linkIcon || standardArrowRightIcon,
      look: "right"
    }, showLinkLabel && linkLabel)))]
  }));
}, defaultProps);
CardsItemPresentation.displayName = "CardsItemPresentation";

export { CardsItemPresentation, defaultProps };
